module.exports = __webpack_public_path__ + "static/media/Farma Pasa - Pustoparan - 09 Farma Pasa - ODMA' MI DAI.1dc46c41.mp3";